import { apm } from '@elastic/apm-rum';
import { UserManager } from 'oidc-client';
import { configuration } from '../configuration';
import { session } from '../utilities/session-storage';
import { win } from '../utilities/window';

// written by public/logged-out-elsewhere.js
export const loggedOutAtKey = 'fasit-logged-out-at';
export const signedInAtKey = 'fasit-signed-in-at';

function rememberSignIn() {
  session.setItem(signedInAtKey, String(Date.now()));
}

function loggedOutAt(): number {
  try {
    return Number(win.localStorage.getItem(loggedOutAtKey)) || 0;
  } catch {
    return 0;
  }
}

// both times are this browser's clock, so the STS's clock cannot make a fresh login look older than the logout
function isLoggedOutSinceSignIn(): boolean {
  const logout = loggedOutAt();
  return logout > 0 && Number(session.getItem(signedInAtKey) ?? 0) < logout;
}

async function endSessionIfLoggedOutElsewhere(userManager: UserManager) {
  if (!isLoggedOutSinceSignIn()) {
    return;
  }

  const user = await userManager.getUser();
  if (!user) {
    return;
  }

  await userManager.removeUser();
  win.location.assign(`${configuration.baseAddress}/logged-out`);
}

/**
 * A logout in another tab, or in another app of the fasit session, leaves this tab's user in its own session storage, so
 * the tab ends it when it sees the mark: at once if it is awake, otherwise when it is shown or started again.
 */
export function endSessionWhenLoggedOutElsewhere(userManager: UserManager) {
  function check() {
    endSessionIfLoggedOutElsewhere(userManager).catch((error: unknown) => apm.captureError(error as Error));
  }

  userManager.events.addUserLoaded(rememberSignIn);
  win.addEventListener('storage', event => {
    if (event.key === loggedOutAtKey) {
      check();
    }
  });
  win.document.addEventListener('visibilitychange', () => {
    if (win.document.visibilityState === 'visible') {
      check();
    }
  });
  check();
}
